import React, { useState } from 'react'

import { Container, ContentHeader, LoadingFeedback, Page } from 'components'
import { CompletedSection, ContractForm } from './components'

const ContractMain = () => {
  const [loading, setLoading] = useState(false)
  const [requestCompleted, setRequestCompleted] = useState(false)

  const handleRequestCompleted = () =>
    setRequestCompleted((prevState) => !prevState)

  return (
    <Page title="Solicitar Análise de Contrato">
      <LoadingFeedback open={loading} />
      <Container maxWidth={false}>
        <ContentHeader title="Solicitar Análise de Contrato" />
        {!requestCompleted ? (
          <ContractForm
            setLoading={setLoading}
            handleRequestCompleted={handleRequestCompleted}
          />
        ) : (
          <CompletedSection handleRequestAgain={handleRequestCompleted} />
        )}
      </Container>
    </Page>
  )
}

export default ContractMain
